import { forwardRef } from 'react';
import { Falcon } from 'modules/macro';
import { IconButton } from 'modules/v2/navigation/buttons';
export const TableRowCollapseButton = forwardRef((props, ref) => {
    const { open, onClick } = props;
    const icon = open ? <Falcon icon="chevron-up"/> : <Falcon icon="chevron-down"/>;
    return (<IconButton ref={ref} size="small" onClick={onClick} aria-expanded={open} appearance="ghost">
      {icon}
    </IconButton>);
});
